/* tslint:disable */
/* eslint-disable */

/**
 * 401130000 = Bachelor (Bachelor)
 * 
 * 401130001 = Master (Master)
 * 
 * 401130002 = Staatsexamen (Staatsexamen)
 */
import {EnumValue} from "@/core/models/enumvalue.model"
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export enum GlobalEnumsAceStudienabschluss {
 Bachelor = 401130000,
 Master = 401130001,
 Staatsexamen = 401130002
}

marker([
    "Enum.GlobalEnumsAceStudienabschluss.Bachelor",
    "Enum.GlobalEnumsAceStudienabschluss.Master",
    "Enum.GlobalEnumsAceStudienabschluss.Staatsexamen"
]);

export namespace GlobalEnumsAceStudienabschluss
{
    class DataSets
    {
        static GlobalEnumsAceStudienabschlussDataSet: Array<EnumValue> = new Array<EnumValue>(
            new EnumValue("Bachelor", 401130000, "Bachelor"),
            new EnumValue("Master", 401130001, "Master"),
            new EnumValue("Staatsexamen", 401130002, "Staatsexamen"),
        )
    }

    export function getAsDataset() {
        return DataSets.GlobalEnumsAceStudienabschlussDataSet;
    }
}
